import { IsString } from 'class-validator';

export class CompanyInformationInquiryDto {
  @IsString()
  companyNationalId!: string;

  @IsString()
  businessName!: string;
}
